import { Body, Box, type BoxProps } from '@hover/blueprint';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';

import { FullscreenImageThumbnail } from 'src/modules/homeownerApp/components/FullscreenImage';
import { Image } from 'src/modules/homeownerApp/components/ProjectShare/Image';
import type { ProjectShareDisplayImages } from 'src/modules/homeownerApp/components/ProjectShare/Images';
import { getAiGeneratedImageStyle } from 'src/modules/homeownerApp/components/ProjectShare/Images';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { Route, generatePath } from 'src/shared/route';
import { imageLoaded } from 'src/shared/telemetry';

export interface MobileImagesProps extends BoxProps {
  aiDisplayImages: ProjectShareDisplayImages;
  orgId?: number | null;
}

export const MobileImages = ({
  aiDisplayImages,
  orgId,
  ...props
}: MobileImagesProps) => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { trackingData } = useHomeownerAppContext();

  useEffect(() => {
    if (aiDisplayImages?.length) {
      aiDisplayImages.forEach(image => {
        imageLoaded({
          ...trackingData,
          ai_original_image_id: image?.aiOriginalImage?.id,
          ai_generated_image_id: image?.aiGeneratedImage?.id,
          feature: 'lead-landing-page',
          page_or_screen_name: 'lead-landing-page',
          track_id: 'lead-landing-image-viewed',
          org_id: orgId ?? undefined,
        });
      });
    }
  }, [aiDisplayImages, orgId, trackingData]);

  return (
    <Box {...props} flexDirection="column">
      {aiDisplayImages.map(image => (
        <Box flexDirection="column">
          <FullscreenImageThumbnail
            image={image}
            onClick={() => {
              history.push(
                generatePath(Route.PROJECT_SHARE_FULLSCREEN.path, {
                  id,
                  aiDisplayImageId: image.id,
                }),
              );
            }}
          >
            <Image borderRadius={400} cursor="pointer" image={image} />
          </FullscreenImageThumbnail>
          <Body fontWeight={700} margin={0} marginBottom={700} marginTop={500}>
            {getAiGeneratedImageStyle(image.aiGeneratedImage.style)}
          </Body>
        </Box>
      ))}
    </Box>
  );
};
